<template>
  <div class="jz_mobi_designer_btn_list" v-if="$store.state.app.view_pattern === 'mb'" style="top:5px">
        <el-tooltip class="item" effect="light" :content="$t('view_public_topbar_4')" placement="right">
          <div class="design_svg_wrap" @click="clickDesign">
              <div class="func_entry_icon"></div>
          </div>
       </el-tooltip>
  </div>

</template>

<script>
import i18n from '../../language/index'

    export default {
      name: "mb_designer_btn",
      methods:{
        clickDesign() {
          this.$store.commit('right_set/set_dialog',true);
          this.$store.commit('app/SET_module_Data',null)
          this.$store.commit('main_dialog/Change_main_dialog_isShow', false)
          this.$store.commit('main_dialog/Change_edit_name', '')
        }
      },

      mounted(){
        this.templet.mb_eye_isShow();

      }
    }
</script>

<style scoped>
.design_svg_wrap {
  background-color: #fff;
  box-shadow: 2px 3px 7px 0 rgba(0,0,0,.2);
  border-radius: 40px;
  transition: background-color,width .2s;
  color: #dae0f8;
  position: relative;
  top: 35px;
}
.func_entry_icon {
    display: inline-block;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 0;
    cursor: pointer;
}
.func_entry_icon:before{
  content: "";
  display: inline-block;
  vertical-align: middle;
  height: 29px;
  width: 29px;
  background-image: url(~@/assets/image/cssSprite.png);
  background-repeat: no-repeat;
  background-position: -674px -195px;
}

</style>


// WEBPACK FOOTER //
// src/components/mb_designer_btn/index.vue